import { useLocation } from 'react-router-dom';

export default (param: string) => {
	const location = useLocation();
	const urlParams = new URLSearchParams(location.search);
	return urlParams.get(param);
};